<template>
    <div>
        <v-snackbars
            :objects.sync="objects"
            color="red"
            bottom
            left
        >
            <template v-slot:action="{ index }">
                <v-icon
                    v-bind:key="index"
                >
                    {{iconoTipo[objects[index].color]}}
                </v-icon>
            </template>
        </v-snackbars>
    </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
    components: {
        VSnackbars: () => import("v-snackbars")
    },
    data: () => ({
        objects: []
    }),
    computed: {
        ...mapGetters('snackbar', ['objecto', 'iconoTipo'])
    },
    watch: {
        objecto() {
            this.objects.push(this.objecto);
        }
    }
}
</script>